import { createContext, useContext, useState, useCallback } from "react";
import { ParticipantsLink } from "./ParticipantsLink";

const ParticipantsContext = createContext();

export const useParticipants = () => {
  const context = useContext(ParticipantsContext);
  if (!context) {
    throw new Error(
      "useParticipants must be used within a ParticipantsProvider"
    );
  }
  return context;
};

export const ParticipantsProvider = ({ children }) => {
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchParticipants = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const link = new ParticipantsLink();
      await link.request();
      setParticipants(link.participants);
    } catch (error) {
      console.error("Failed to fetch participants:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const updateParticipantAttendance = useCallback((playerId, newAttendance) => {
    setParticipants((prevParticipants) =>
      prevParticipants.map((p) => {
        if (p.playerId === playerId) {
          const updated = Object.assign(
            Object.create(Object.getPrototypeOf(p)), // 프로토타입 유지
            p, // 기존 속성 복사
            { attendance: newAttendance } // attendance만 업데이트
          );
          return updated;
        }
        return p;
      })
    );
  }, []);

  const value = {
    participants,
    loading,
    error,
    fetchParticipants,
    updateParticipantAttendance,
  };

  return (
    <ParticipantsContext.Provider value={value}>
      {children}
    </ParticipantsContext.Provider>
  );
};